"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryCountObj = getCategoryCountObj;
exports.getFollowingGtlds = void 0;
exports.getStatusCountObj = getStatusCountObj;
exports.modifyCategories = modifyCategories;
// eslint-disable-next-line max-params
function modifyCategories(categories, viewAllGtldsId, followingGtldsId, viewAllCategoryLabel = 'View All', followingCategoryLabel = 'Following') {
  const viewAllItem = {
    id: viewAllGtldsId,
    name: viewAllCategoryLabel,
    checked: false
  };
  const followingItem = {
    id: followingGtldsId,
    name: followingCategoryLabel,
    checked: false
  };
  const mappedCategories = categories?.map(category => ({
    ...category,
    checked: false
  }));
  return [viewAllItem, followingItem, ...mappedCategories];
}
function followingGtldObjects(followingGtlds, gtlds) {
  const followingObj = Object.fromEntries(followingGtlds?.map(gtld => [gtld, true]));
  gtlds.forEach(gtld => {
    if (gtld.p === 2 || gtld.p === 3) {
      delete followingObj[gtld.name];
    }
  });
  return followingObj;
}
function getCategoryCountObj(categories) {
  const categoryObj = {};
  for (const category of categories) {
    categoryObj[category.id] = 0;
  }
  return categoryObj;
}
function getStatusCountObj(statuses) {
  const statusesObj = {};
  for (const status of statuses) {
    statusesObj[status.id] = 0;
  }
  return statusesObj;
}
const getFollowingGtlds = (url, gtlds) => {
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    if (response?.ok) {
      return response.json();
    }
    throw new Error('Network response was not ok.');
  }).then(data => {
    if (data?.Success && data.Tlds) {
      return followingGtldObjects(data.Tlds, gtlds);
    }
    return {};
  }).catch(error => {
    return error;
  });
};
exports.getFollowingGtlds = getFollowingGtlds;